const namedRoutes = {
  home: "/",
  whyAttend: "/why-attend/",
  speakers: "/speakers/",
  details: "/details/",
  faq: "/details/#faq",
  history: "/history/",
  contact: "/contact/",
  classes: "/classes/",
  merch: "/merch/",
  vendors: "/vendors/",
  sponsors: "/sponsors/",

  // External links
  tickets: "https://www.zeffy.com/en-US/ticketing/sarposium--2026",
  donate:
    "https://www.zeffy.com/en-US/donation-form/king-county-sarposium--2026",
};

export default namedRoutes;
